import EmblaCarousel from 'embla-carousel';
// import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButton';
import '~/css/vendors/embla.css';

const DEFAULT_OPTIONS = { align: 'start' };

export function initEmblaSlider(viewportNode, dotsNode, options = {}) {
  const mergedOptions = { ...DEFAULT_OPTIONS, ...options };
  const emblaApi = EmblaCarousel(viewportNode, mergedOptions);

  return emblaApi;
}
